import { borderRadius, breakpoint, color } from '@core-ds/primitives';

import styles from './styles';
import shadow from './foundations/shadow';
import space from './foundations/space';
import typography from './foundations/typography';
import Avatar from './components/Avatar';
import Badge from './components/Badge';
import Button from './components/Button';
import Input from './components/Input';
import Link from './components/Link';
import Modal from './components/Modal';
import Select from './components/Select';
import Tabs from './components/Tabs';
import Tooltip from './components/Tooltip';

export const theme = {
   styles,
   breakpoints: { ...breakpoint, base: '0px', '2xl': '1536px' },
   colors: { ...color },
   radii: { ...borderRadius, base: borderRadius.md, full: borderRadius.pill },
   shadows: shadow,
   space,
   ...typography,
   components: {
      Avatar,
      Badge,
      Button,
      Input,
      Link,
      Modal,
      Select,
      Tabs,
      Tooltip,
   },
};
